'use client';

import { useEffect } from 'react';
import { reinitAccountUmSession } from '@/hooks/use-account-um';
import { TIMERS_IN_MS } from '@/utils/constants';
import { useGlobalContext } from '@/store/contexts/global-context';

export const usePokerSessionRefresh = () => {
    const { isPokerWrapper } = useGlobalContext();

    useEffect(() => {
        if (!isPokerWrapper) return;

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                reinitAccountUmSession('visibility');
            }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);

        const interval = window.setInterval(() => reinitAccountUmSession('interval'), TIMERS_IN_MS.ONE_MINUTE * 5);

        return () => {
            document.removeEventListener('visibilitychange', onVisibilityChange);
            window.clearInterval(interval);
        };
    }, [isPokerWrapper]);
};
